import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import cx from 'classnames';
import { Row } from '../../../atoms/row/Row';
import { Radio } from '../../../atoms/radio/Radio';
import { Typography } from '../../../atoms/typography/Typography';
import { Close } from '../../../../../static/icons/close';
import { cnMerge } from '../../../../utils/utils';

const RadioQuestion = ({
  answers,
  questionId,
  formName,
  // locale,
  error,
  required = false,
  horizontal = false,
  clearVisible = false,
}) => {
  const { setValue, control, watch } = useFormContext();
  const currentName = formName ?? `question-${questionId}`;
  const current = watch(currentName);
  const disableClearButton = !current;

  const onChangeCustom = (answer, onChange) => {
    if (onChange) {
      onChange(answer);
    } else {
      setValue(currentName, answer);
    }
  };

  const clearValue = () => {
    setValue(currentName, '');
  };

  return (
    <div className="flex flex-col md:flex-row gap-3">
      <div
        className={cx('flex flex-wrap gap-2 md:gap-4', {
          'flex-col sm:flex-row': horizontal,
          'sm:grid sm:grid-cols-2': !horizontal,
        })}
      >
        <Controller
          control={control}
          name={currentName}
          rules={{ required }}
          render={({ field }) =>
            answers.map((answer) => (
              <Row
                key={answer.value}
                onClick={() => onChangeCustom(answer.value, field.onChange)}
                className={cnMerge(
                  `py-3 ${
                    horizontal ? 'w-full sm:w-auto px-4' : 'pl-4 pr-6 w-full'
                  } bg-[#EAF5FB] rounded-3xl gap-3 global-hover items-center`,
                  {
                    'ring-1 ring-red-500': error,
                  }
                )}
              >
                <Radio
                  value={answer}
                  name={currentName}
                  checked={current && current === answer.value}
                  onChange={() => onChangeCustom(answer.value, field.onChange)}
                />
                <Typography
                  fontVariant="md"
                  textAlign="left"
                  className="!text-customGray-700"
                >
                  {answer.text}
                </Typography>
              </Row>
            ))
          }
        />
        {clearVisible && (
          <button
            type="button"
            onClick={clearValue}
            aria-label="Close"
            className="flex w-9 h-9 self-start md:self-center justify-center items-center border border-customGray-300 rounded-full global-hover disabled:opacity-25 disabled:cursor-default"
            disabled={disableClearButton}
          >
            <Close width={18} height={18} />
          </button>
        )}
      </div>
    </div>
  );
};

export default RadioQuestion;
